module.exports = __webpack_public_path__ + "img/pt-36.fe74fca6.jpg";